var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('entry-layout',[_c('v-row',[_c('v-col',{attrs:{"offset-xl":"3","xl":"6","offset-lg":"2","lg":"8","offset-md":"1","md":"10","offset-sm":"1","sm":"10"}},[_c('event-card',{attrs:{"value":_vm.event,"user":_vm.$store.getters.user}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }